<app-client-task-history-item-title>
  {{ status | titlecase }}
</app-client-task-history-item-title>
<app-client-task-history-item-body>
  <div class="my-2 h5">{{ taskName }} task transitioned to {{ status | titlecase }}</div>
</app-client-task-history-item-body>
